export default "__VITE_ASSET__CZiVGjN0__"